module.exports = __webpack_public_path__ + "static/img/15.8c2cd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITInfrastructure/15.png
// module id = bChk
// module chunks = 1